/**
 * Company / brand constants — single source of truth.
 *
 * Any UI that renders official brand marks, contact info, or legal identifiers
 * pulls from this file. NEVER hardcode these values elsewhere.
 */

export const COMPANY = {
  brand: "SociBaba",
  brandMark: "™", // trademark (Indian trademark filing)
  legalName: "SOCIBABA",
  cin: "U74999KA2020PTC134970",
  gst: "29ABDCS7875E1ZU",
  address: {
    line1: "#122, First Floor, 3rd Cross",
    line2: "Chowdeshwari Nagara, Hosa Byrohalli",
    line3: "Archakara Layout 2nd Stage, Sulikere",
    city: "Bengaluru",
    state: "Karnataka",
    pincode: "560060",
    country: "India",
  },
  supportEmail: "support@socibaba.com",
  customerCarePhone: "+91 97399 59565",
  customerCarePhoneRaw: "+919739959565", // for tel: links
  supportHours: "Mon–Fri · 10 AM to 5 PM IST",
  // ── Social + WhatsApp shortcuts (Feb 2026 · added for Contact FAB) ──
  whatsappRaw: "+919739959565",
  whatsappUrl: "https://wa.me/919739959565",
  linkedinUrl: "https://www.linkedin.com/company/socibaba",
  founderLinkedinUrl: "https://www.linkedin.com/in/yesuraj/",
  xUrl: "https://x.com/socibaba",
  instagramUrl: "https://www.instagram.com/socibaba",
} as const;

export const ADDRESS_LINES = [
  COMPANY.address.line1,
  COMPANY.address.line2,
  COMPANY.address.line3,
  `${COMPANY.address.city}, ${COMPANY.address.state} ${COMPANY.address.pincode}`,
  COMPANY.address.country,
];

/** Compact single-line address (for schema.org / plain text). */
export const ADDRESS_ONELINE = [
  COMPANY.address.line1,
  COMPANY.address.line2,
  COMPANY.address.line3,
  COMPANY.address.city,
  COMPANY.address.state,
  COMPANY.address.pincode,
  COMPANY.address.country,
].join(", ");
